import type { McRun } from "../../lib/mc";
import NewTabLink from "./NewTabLink";
import { capitalize, githubPrUrl, runPr } from "./format";

const triggerLabel = (run: McRun) => capitalize(run.trigger || "unknown");

/** The trigger with the PR it's about (linked to GitHub when the repo is known), or else its commit. */
export function RunTriggerCell({ run }: { run: McRun }) {
  const pr = runPr(run);
  const repo = run.source?.repo;
  return (
    <div className="min-w-0">
      <div>{triggerLabel(run)}</div>
      {pr && repo ? (
        <div className="truncate text-[13px]" title={run.source?.prTitle}>
          <NewTabLink href={githubPrUrl(repo, pr)} size="small">
            PR #{pr}
          </NewTabLink>
        </div>
      ) : pr ? (
        <div className="text-[13px] text-gray-500">PR #{pr}</div>
      ) : run.sha ? (
        <div className="font-mono text-[13px] text-gray-500">
          {run.sha.slice(0, 7)}
        </div>
      ) : null}
    </div>
  );
}

/** The trigger and the PR with its title. */
export function RunTriggerDetail({ run }: { run: McRun }) {
  const pr = runPr(run);
  const { repo, prTitle } = run.source ?? {};
  const prText = prTitle ? `PR #${pr}: ${prTitle}` : `PR #${pr}`;
  return (
    <div className="flex flex-col gap-1">
      <span>{triggerLabel(run)}</span>
      {pr &&
        (repo ? (
          <NewTabLink href={githubPrUrl(repo, pr)}>{prText}</NewTabLink>
        ) : (
          <span>{prText}</span>
        ))}
    </div>
  );
}
